import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { areAllVersionsSelected } from 'selectors/Selected';
import { clearLevel, selectMultiple } from "reducers/Selected";
import SelectAllCell from "widgets/grid/cells/SelectAllCell.js";


export default function SelectAllCreativesCell() {
	let dispatch = useDispatch();

	let { versions, isAllSelected } = useSelector((state) => {
		return {
			versions: state.creativeVersions.items,
			isAllSelected: areAllVersionsSelected(state),
		};
	});

	function toggleSelectAll() {
		if (isAllSelected) {
			dispatch(clearLevel('versions'));
		} else {
			dispatch(selectMultiple(versions.map(version => version.id), 'versions', true));
		}
	}

	return (
		<SelectAllCell className="select-all-versions" column={{ selectAll: toggleSelectAll, isAllSelected }} />
	);
}

SelectAllCreativesCell.displayName = "SelectAllVersionsCell";
